import Types from "./types";
import { VehicleService } from "../../../service/vehicle-service";
import { CarService } from "../../../service/car-service";

const fetchTestimonialsSuccess = (data) => ({
    type: Types.FETCH_TESTIMONIALS_SUCCESS,
    list: data
});

const fetchSEOTestimonialsSuccess = (data) => ({
    type: Types.FETCH_SEO_TESTIMONIALS_SUCCESS,
    list: data.reviewData
});

const fetchTestimonialsFailure = () => ({ type: Types.FETCH_TESTIMONIALS_FAILURE });

const fetchTestimonials = (payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
        VehicleService.fetchTestimonials(payload)
            .then(response => {
                dispatch(fetchTestimonialsSuccess(response.data.detail));
                resolve(response);
            }).catch(error => {
                dispatch(fetchTestimonialsFailure());
                reject(error);
            });
    });
};

const fetchTestimonialsByCategory = (payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
        VehicleService.fetchTestimonialsByCategory(payload)
            .then(response => {
                dispatch(fetchTestimonialsSuccess(response.data.detail));
                resolve(response);
            }).catch(error => {
                dispatch(fetchTestimonialsFailure());
                reject(error);
            });
    });
};

const fetchSeoReviews = (payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
        CarService.fetchSEOReviews(payload)
            .then(response => {
                dispatch(fetchSEOTestimonialsSuccess(response));
                resolve(response);
            }).catch(error => {
                dispatch(fetchTestimonialsFailure());
                reject(error);
            });
    });
};

const setIsSSR = (isSSR) => ({
    type: Types.SET_IS_SSR,
    isSSR
});

export {
    fetchTestimonials,
    fetchSeoReviews,
    setIsSSR,
    fetchTestimonialsByCategory
};
